import * as ko from "knockout";
import {AbstractParameter, IAbstractParams} from "./AbstractParameter";
import {nsForm} from "../../../../nsForm";
import str2Bool = nsForm.str2Bool;
import bool2Str = nsForm.bool2Str;
import booleanHtml from './boolean.html?raw';

export let template = booleanHtml;

export class viewModel extends AbstractParameter {
    private readonly toggle: KnockoutObservable<boolean | null> = ko.observable(null);

    constructor(params: IAbstractParams) {
        super(params);
        this.kosub.subscribe(this.toggle, bool => {
            if (bool !== null) {
                this.parameter.val(bool2Str(bool))
            }
        });
        this.kosub.subscribe(this.parameter.val, str => {
            this.toggle(str2Bool(str));
        });
        this.toggle(str2Bool(this.parameter.val()));
    }
}
